import { RootState } from '../redux/root-state';

export const getCurrentVideoId = (state: RootState) => state.currentVideoId;
export const isSingleVideo = (state: RootState) => !!state.currentVideoId;
